import React, { useEffect, useState } from "react";
import styled from "styled-components";
import Image from "../parts/Image";
import Tag from "../parts/Tag";
import Text from "../parts/Text";
import Divider from "../parts/Divider";
import { Link } from "react-router";
import {
  GetPublicShops200ResponseInner,
  GetUserSession200Response,
  GetCafeNotes200ResponseInner,
} from "../../../api/v1";
import { api } from "../../../api";
import FavoriteShopButton from "./FavoriteShopButton";
import CafeNoteButton from "./CafeNoteButton";
import cafectSampleImage from "../../assets/images/cafect_sample.webp";

type ShopListComponentProps = {
  shops: Array<GetPublicShops200ResponseInner>;
};

const ShopCardsStyle = styled(Link)`
  display: flex;
  border-top: 1px solid #dbdbdb;
  text-decoration: none;
  padding: 30px;

  @media (max-width: 767px) {
    flex-direction: column;
    padding: 12px;
  }

  &:hover {
    background-color: #eeeeee;
    transition: background-color 0.3s ease-in-out;
  }
`;

const ShopCardColumnLeft = styled.div`
  margin-right: 20px;

  @media (max-width: 767px) {
    display: none;
  }
`;

const ShopCardColumnCenter = styled.div`
  margin-right: 20px;

  @media (max-width: 767px) {
    margin: 0;
  }

  img {
    @media (max-width: 767px) {
      width: 100%;
    }
  }
`;

const ShopCardColumnRight = styled.div`
  width: 100%;
`;

const ShopCardColumnRightHeading = styled.div`
  display: flex;
  justify-content: space-between;
`;

const ShopButtons = styled.div`
  display: none;

  @media (max-width: 767px) {
    display: flex;
    column-gap: 8px;

    button {
      margin-bottom: 0;
      width: 38px;
      height: 38px;

      svg {
        font-size: 14px;
      }
    }
  }
`;

const ShopInformation = styled.div``;

const ShopList: React.FC<ShopListComponentProps> = ({ shops }) => {
  const [session, setSession] = useState<GetUserSession200Response>(null);
  const [cafeNotes, setCafeNotes] = useState<GetCafeNotes200ResponseInner[]>(
    []
  );

  useEffect(() => {
    api
      .getUserSession()
      .then((response) => {
        setSession(response.data);
      })
      .catch(() => setSession(null));
  }, []);

  useEffect(() => {
    api
      .getCafeNotes()
      .then((response) => {
        setCafeNotes(response.data);
      })
      .catch(() => setCafeNotes([]));
  }, []);

  return (
    <>
      {shops.map((shop, index) => {
        return (
          <ShopCardsStyle key={shop.id} to={`/shops/${shop.id}`}>
            <ShopCardColumnLeft>
              <FavoriteShopButton
                shopId={shop.id}
                favoriteFlag={shop.favoriteFlag}
                session={session}
              />
              <CafeNoteButton
                cafeNoteId={
                  cafeNotes.find((cafeNote) => cafeNote.shopId === shop.id)?.id
                }
                shopId={shop.id}
                shopName={shop.name}
                session={session}
              />
            </ShopCardColumnLeft>
            <ShopCardColumnCenter>
              <Image
                src={shop.images[0] ? shop.images[0]?.url : cafectSampleImage}
                width="300px"
                height="170px"
                loading={index > 3 ? "lazy" : null}
                alt="店舗画像"
              />
            </ShopCardColumnCenter>
            <ShopCardColumnRight>
              <ShopCardColumnRightHeading>
                <Text size="24px" weight="bold" mb="5px">
                  {shop.name}
                </Text>
                <ShopButtons>
                  <FavoriteShopButton
                    shopId={shop.id}
                    favoriteFlag={shop.favoriteFlag}
                    session={session}
                  />
                  <CafeNoteButton
                    cafeNoteId={
                      cafeNotes.find((cafeNote) => cafeNote.shopId === shop.id)
                        ?.id
                    }
                    shopId={shop.id}
                    shopName={shop.name}
                    session={session}
                  />
                </ShopButtons>
              </ShopCardColumnRightHeading>
              <Text size="14px" mb="10px">
                {shop.description}
              </Text>
              <ShopInformation>
                {shop.owner && <Tag mr="5px">公式</Tag>}
                {shop.nearestStation && (
                  <Tag mr="5px">{shop.nearestStation}</Tag>
                )}
                {shop.features
                  .map((feature) => feature.name)
                  .includes("モーニング") && <Tag mr="5px">モーニング</Tag>}
                {shop.features
                  .map((feature) => feature.name)
                  .includes("ランチ") && <Tag mr="5px">ランチ</Tag>}
                {shop.features
                  .map((feature) => feature.name)
                  .includes("ディナー") && <Tag>ディナー</Tag>}
                <Divider mt="5px" mb="5px" />
                <Text size="12px">住所：{shop.address}</Text>
                <Text size="12px">TEL：{shop.tel}</Text>
              </ShopInformation>
            </ShopCardColumnRight>
          </ShopCardsStyle>
        );
      })}
    </>
  );
};

export default ShopList;
